/**
 * @generated SignedSource<<8b2f6744bdd963d997426301388f794c>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type colorPickerView_paletteColorsQuery$variables = {
  paletteId?: string | null;
  paletteTypeID?: number | null;
  search?: string | null;
};
export type colorPickerView_paletteColorsQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"colorPickerView_paletteColorsFragment">;
};
export type colorPickerView_paletteColorsQuery = {
  response: colorPickerView_paletteColorsQuery$data;
  variables: colorPickerView_paletteColorsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paletteId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paletteTypeID"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v3 = {
  "kind": "Variable",
  "name": "paletteTypeID",
  "variableName": "paletteTypeID"
},
v4 = {
  "kind": "Variable",
  "name": "search",
  "variableName": "search"
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  },
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "paletteId"
  },
  {
    "kind": "Literal",
    "name": "orderBy",
    "value": "DESC"
  },
  (v3/*:: as any*/),
  (v4/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "colorPickerView_paletteColorsQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "paletteId",
            "variableName": "paletteId"
          },
          (v3/*:: as any*/),
          (v4/*:: as any*/)
        ],
        "kind": "FragmentSpread",
        "name": "colorPickerView_paletteColorsFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "colorPickerView_paletteColorsQuery",
    "selections": [
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "concreteType": "PaletteColorsConnection",
        "kind": "LinkedField",
        "name": "paletteColors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "PaletteColorsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PaletteColor",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "colorID",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "name",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rgbHexCode",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "spotColorName",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "cursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v5/*:: as any*/),
        "filters": [
          "id",
          "search",
          "paletteTypeID",
          "orderBy"
        ],
        "handle": "connection",
        "key": "colorPickerView_paletteColors_paletteColors",
        "kind": "LinkedHandle",
        "name": "paletteColors"
      }
    ]
  },
  "params": {
    "cacheID": "f90e0eeca9c98119048dbc34e7ec72ca",
    "id": null,
    "metadata": {},
    "name": "colorPickerView_paletteColorsQuery",
    "operationKind": "query",
    "text": "query colorPickerView_paletteColorsQuery(\n  $paletteTypeID: Int\n  $paletteId: String\n  $search: String\n) {\n  ...colorPickerView_paletteColorsFragment_3sX8WJ\n}\n\nfragment colorPickerView_paletteColorsFragment_3sX8WJ on Query {\n  paletteColors(first: 50, id: $paletteId, search: $search, paletteTypeID: $paletteTypeID, orderBy: \"DESC\") {\n    edges {\n      node {\n        id\n        colorID\n        name\n        rgbHexCode\n        spotColorName\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6917f6fd78db14b9e1817fbc5a1c3afb";

export default node;
